<template>
    <div class="overlay" :class="name" v-if="isOpen">
        <div class="imodal" :class="{widescreen}" :style="styler">
            <div class="modal-header">
                <div class="close-btn fal fa-times" @click="modalClose" />
                <slot name="title"></slot> {{title}}
            </div>
            <div class="modal-body" :style="{height:(height-(noFooter?47:78))+'px',padding:padding+'px'}">
                <slot></slot>
            </div>
            <div v-if="!noFooter" class="modal-footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: "modal",
    methods: {
        modalClose() {
            this.$store.commit('modalClose', this.name);
            this.$emit('onClose');
        }
    },
    description: `open with this.$store.commit('modalOpen', modalName); `,
    example: `<modal name="modal-name" :height="560" :width="800">
				<div slot="title">
					...title content
				</div>
				...content
				<div slot="footer">
					...footer content
				</div>
			</modal>`,
    created() {},
    props: {
        name: { type: String, required: true },
        title: { type: String, default: '' },
        padding: { type: [String, Number], default: '0' },
        widescreen: {
            type: Boolean,
            default: false
        },
        height: {
            type: [Number, String],
            default: 500
        },
        width: {
            type: [Number, String],
            default: 700
        }
    },
    mounted() {
        let self = this;
        if (!this.$store.state.modals) {
            this.$store.registerModule('modals', {
                state: {},
                mutations: {
                    modalClose(state, modalName) {
                        state[modalName] = false;
                    },
                    modalOpen(state, modalName) {
                        state[modalName] = true;
                    },
                    initModal(state, modalName) {
                        console.log(state);
                        state[modalName] = false;
                    }
                }
            });
        }

        this.$store.subscribe((mutation, state) => {
            if ((mutation.type === 'modalOpen' || mutation.type === 'modalClose') && mutation.payload === self.name) {
                self.$emit('open');
                self.$forceUpdate();
            }
        });


    },
    computed: {
        noFooter() {
            return !this.$slots.footer;
            return false;
        },
        isOpen: {
            cache: false,
            get() {
                return this.$store.state.modals && this.$store.state.modals[this.name] || false;
            }
        },
        styler() {
            let { height, width } = this;
            if (this.widescreen) {
                return {
                    width: '98%',
                    height: '98%',
                    top: 0,
                    left: 0,
                    marginTop: '0.5%',
                    marginLeft: '1%'
                }
            }
            return {
                height: height + 'px',
                width: width + 'px',
                marginTop: -(height / 2) + 'px',
                marginLeft: -(width / 2) + 'px'
            };
        }
    }
}

import Vue from 'vue';

Vue.mixin({
    methods: {
        openModal(modalName) {
            this.$store.commit("modalOpen", modalName);
        },
        closeModal(modalName) {
            this.$store.commit("modalClose", modalName);
        }
    }
})
</script>
<style scoped>
.overlay {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;

}

.modal-header {
    /*background: whitesmoke;*/
    border-bottom: 1px solid lightgrey;
    padding: 8px 8px 8px 12px;
    overflow: hidden;
}

.modal-body {
    padding: 0;
    overflow-y: auto;
}

.modal-footer {
    text-align: right;
    background: whitesmoke;
    border-top: 1px solid lightgrey;
    padding: 2px;
    overflow: hidden;
}

.imodal {
    position: absolute;
    top: 50%;
    left: 50%;
    background: white;
    border-radius: 4px;
    overflow: hidden;
}

.modal-body>.body {
    padding: 4px 8px;
}

.imodal.widescreen .modal-body {
    height: calc(100% - 37px) !important;
}

.close-btn {
    float: right;
    cursor: pointer;
    padding: 2px;
    color: lightgrey;
}

.close-btn:hover {
    color: grey;
}
</style>